import axios from 'axios';
import { ApiEndpoints } from '../../constants/ApiEndpoints';
import { baseRequest } from '../../utils/HttpClient';
import getConfig from '../../config';

export const createCalendar = (bodyRequest, queryParams) => {
  return baseRequest(ApiEndpoints.ADD_GOOGLE_CALENDER_SETTINGS, bodyRequest, null, queryParams);
};

export const getGoogleCalendarEvents = bodyRequest => {
  return baseRequest(ApiEndpoints.GET_ALL_GOOGLE_CALENDAR_EVENTS, bodyRequest, null, null);
};
export const deleteGoogleCalendarEvents = bodyRequest => {
  return baseRequest(ApiEndpoints.DELETE_CALENDAR_EVENTS, bodyRequest, null, null);
};

export const getCalendars = queryParams => {
  return baseRequest(ApiEndpoints.GET_GOOGLE_CALENDER_SETTINGS, null, null, queryParams);
};

export const updateCalendar = (bodyRequest, queryParams) => {
  return baseRequest(ApiEndpoints.UPDATE_GOOGLE_CALENDER_SETTINGS, bodyRequest, null, queryParams);
};

export const deleteCalendar = queryParams => {
  return baseRequest(ApiEndpoints.DELETE_GOOGLE_CALENDER_SETTINGS, null, null, queryParams);
};

export const alllowCalendarAccess = bodyRequest => {
  return baseRequest(ApiEndpoints.ALLOW_ACCESS_GOOGLE_CALENDAR, bodyRequest, null, null);
};
export const syncConfidantToGoogle = bodyRequest => {
  return baseRequest(ApiEndpoints.SYNC_CONFIDANT_TO_GOOGLE_CALENDAR, bodyRequest, null, null);
};

export const syncGoogleToConfidant = bodyRequest => {
  return baseRequest(ApiEndpoints.SYNC_GOOGLE_TO_CONFIDANT, bodyRequest, null, null);
};

export const getAllCalendarsFromAccessToken = requestBody => {
  return baseRequest(ApiEndpoints.GET_ALL_CALENDARS_WITH_ACCESS_TOKEN, requestBody, null, null);
};

export const sendSupportEmail = bodyRequest => {
  return baseRequest(ApiEndpoints.SEND_SUPPORT_EMAIL, bodyRequest, null, null);
};

export const addProvider = bodyRequest => {
  return baseRequest(ApiEndpoints.ADD_PROVIDER_NEW, bodyRequest, null, null, true);
};

export const getTopProviders = queryParams => {
  return baseRequest(ApiEndpoints.GET_TOP_PROVIDERS, null, null, queryParams);
};

export const createToDo = bodyRequest => {
  return baseRequest(ApiEndpoints.CREATE_TODO, bodyRequest, null, null);
};

export const updateTodo = bodyRequest => {
  return baseRequest(ApiEndpoints.UPDATE_TODO, bodyRequest, null, null);
};

export const shareAlfieValidation = bodyRequest => {
  return baseRequest(ApiEndpoints.SHARE_ALFIE_VALIDATION, bodyRequest, null, null);
};

export const listTodos = payload => {
  return baseRequest(ApiEndpoints.LIST_TODOS, null, null, payload);
};
export const completeTodos = bodyRequest => {
  return baseRequest(ApiEndpoints.COMPLETE_TODOS, bodyRequest, null, null);
};

export const addMemberOrMembersInBulk = payload => {
  return axios.post(`${getConfig.api.baseUrl}/profile/member`, payload, {
    headers: {
      Authorization: localStorage.getItem('authorizationToken'),
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getElkProfileElementAssignmentChatBotList = body => {
  return baseRequest(ApiEndpoints.GET_ELK_PROFILE_ELEMENT_ASSIGNMENT_CHATBOT, body, null, null, false, false);
};

export const getElkProfileElementAssignmentEvaluationList = body => {
  return baseRequest(
    ApiEndpoints.GET_ELK_PROFILE_ELEMENT_ASSIGNMENT_EVALUATION,
    body,
    null,
    null,
    false,
    false,
  );
};

export const getElkProfileElementDctConvoList = body => {
  return baseRequest(ApiEndpoints.GET_ELK_PROFILE_ELEMENT_DCT_CONVO, body, null, null, false, false);
};

export const getElkProfileElementDctEvaluationList = body => {
  return baseRequest(ApiEndpoints.GET_ELK_PROFILE_ELEMENT_DCT_EVALUATION, body, null, null, false, false);
};

export const getElkProfileElementPriorityDataDomainList = body => {
  return baseRequest(
    ApiEndpoints.GET_ELK_PROFILE_ELEMENT_PRIORITY_DATA_DOMAIN,
    body,
    null,
    null,
    false,
    false,
  );
};

export const getTodosStats = payload => {
  return baseRequest(ApiEndpoints.TODO_STATS, null, payload, null);
};

export const getAllModalities = pathParams => {
  return baseRequest(ApiEndpoints.GET_ALL_MODALITIES, null, pathParams, null);
};

export const getPatientModalities = providerId => {
  return baseRequest(ApiEndpoints.GET_PATIENT_MODALITIES, null, { providerId }, null);
};

export const getPatientTreatmentPlan = (memberId, queryParams) => {
  return baseRequest(ApiEndpoints.GET_PATIENT_TREATMENT_PLAN, null, { memberId }, queryParams);
};

export const getAllPatientTreatmentPlans = memberId => {
  return baseRequest(ApiEndpoints.GET_ALL_PATIENT_TREATMENT_PLANS, null, { memberId });
};

export const getPatientTreatmentPlanRecommendations = sessionId => {
  return baseRequest(ApiEndpoints.GET_TREATMENT_PLAN_RECOMMENDATIONS, null, { sessionId });
};

export const consumeAllTreatmentRecommendations = appointmentId => {
  return baseRequest(ApiEndpoints.USE_ALL_TREATMENT_RECOMMENDATIONS, { appointmentId });
};

export const updatePatientTreatmentPlan = (memberId, payload) => {
  return baseRequest(ApiEndpoints.UPDATE_PATIENT_TREATMENT_PLAN, payload, { memberId }, null);
};

export const updatePatientModalities = (providerId, payload) => {
  return baseRequest(ApiEndpoints.UPDATE_PATIENT_MODALITIES, payload, { providerId }, null);
};

export const getUsersSummary = requestBody => {
  return baseRequest(ApiEndpoints.USERS_SUMMARY, requestBody);
};

export const addUpdateDefaultCareNavigator = requestBody => {
  return baseRequest(ApiEndpoints.ADD_UPDATE_DEFAUTL_CARE_NAVIGATOR, requestBody);
};

export const getDefaultCareNavigator = queryParams => {
  return baseRequest(ApiEndpoints.GET_DEFAUTL_CARE_NAVIGATOR, null, null, queryParams);
};

export const getCareNavigatorAliases = queryParams => {
  return baseRequest(ApiEndpoints.GET_CARE_NAVIGATOR_ALIAS_ACCOUNTS, null, null, queryParams);
};

export const deleteCareTeamConnection = (param, queryParams) => {
  return baseRequest(ApiEndpoints.DELETE_MEMBER_CONNECTION, null, param, queryParams, true);
};

export const createConstruct = (requestBody, queryParams) => {
  return baseRequest(ApiEndpoints.CREATE_CONSTRUCT, requestBody, null, queryParams, true);
};

export const getConstructs = (param, queryParams) => {
  return baseRequest(ApiEndpoints.GET_CONSTRUCTS, null, param, queryParams, true);
};

export const getMemberConstructs = memberId => {
  return baseRequest(ApiEndpoints.GET_MEMBER_CONSTRUCTS, null, { memberId }, null, true);
};

export const getMemberConstructsByName = (param, searchString) => {
  return baseRequest(
    {
      path: `/profile/constructs/member/{memberId}?constructs=${decodeURI(searchString)}`,
      method: 'GET',
    },
    null,
    param,
    null,
    true,
  );
};

export const updateConstruct = (requestBody, param, queryParams) => {
  return baseRequest(ApiEndpoints.UPDATE_CONSTRUCT, requestBody, param, queryParams, true);
};

export const deleteConstruct = param => {
  return baseRequest(ApiEndpoints.DELETE_CONSTRUCT, null, param, null, true);
};

export const labRequestTests = () => {
  return baseRequest(ApiEndpoints.LAB_REQUEST_TESTS, null, null, null, true);
};
